<template>
 <div class="tableDiv">
  <el-table :data="tableData" stripe style="width: 100%" :empty-text="$t('desc.noData')">
    <el-table-column type="index" :label="$t('title.serialNumber')" width="60"> </el-table-column>
    <el-table-column prop="kType" :label="$t('title.productLine')"> </el-table-column>
    <el-table-column v-if="isShowKType" prop="kProduct" :label="$t('title.productCategories')">
    </el-table-column>
    <el-table-column v-if="isShowKSmall" prop="kSmall" :label="$t('title.smallClassProduct')">
    </el-table-column>
    <el-table-column v-if="isShowKKproduct" prop="kPower" :label="$t('title.machineType')">
    </el-table-column>
    <el-table-column prop="brand" :label="$t('title.brandName')"> </el-table-column>
    <el-table-column v-if="isShowKKproduct" prop="productFamily" :label="$t('title.productFamily')"> </el-table-column>
    <el-table-column v-if="isShowKKproduct" prop="power" :label="$t('title.power')"> </el-table-column>
    <el-table-column v-if="isShowKKproduct" prop="dischargePressure" :label="$t('title.dischargePressure')"> </el-table-column>
    <el-table-column v-if="isShowKKproduct" prop="coolingMode" :label="$t('title.coolingMode')">
      <template slot-scope="scope">
        {{ translatecoodType(scope.row.coolingMode) }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('title.operate')" width="110" fixed="right">
      <template slot-scope="scope">
        <el-button
        v-if="hasUpdateAuth"
          type="primary"
          icon="el-icon-edit"
          :title="$t('button.update')"
          circle
          size="mini"
          @click="showEditDialog(scope.row)"
        ></el-button>
        <template v-if="hasDeleteAuth">
          <el-popconfirm
            placement="top"
            :confirmButtonText="$t('button.delete')"
            :cancelButtonText="$t('button.cancel')"
            icon="el-icon-info"
            iconColor="red"
            :title="$t('title.confirmDelete')"
            @confirm="delRow(scope.$index, scope.row, tableType)"
          >
            <el-button
              type="danger"
              icon="el-icon-delete"
              :title="$t('button.delete')"
              circle
              size="mini"
              slot="reference"
            ></el-button>
          </el-popconfirm>
        </template>
      </template>
    </el-table-column>
  </el-table>
 </div>
</template>

<script>
export default {
  name: "index",
  props: {
    hasUpdateAuth: false,
    hasDeleteAuth: false,
    isShowKType: false,
    isShowKSmall: false,
    isShowKKproduct: false,
    tableType:"",
    tableData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    addMTRow() {
      this.$emit("addMTRow", true);
    },
    //空压机类型 删除
    delRow(index, row,tableType) {
      this.$emit("delRow", index, row,tableType);
    },
    showEditDialog(row){
        this.$emit("showEditDialog", true, row);
    },
    translatecoodType(name){
      return this.$t('coodMode.'+name).indexOf(".")>-1?name:this.$t('coodMode.'+name)
    },
  },
};
</script>

<style>
</style>
